import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { PagesContext } from '../store/PagesContext';

import Decisions from 'routes/decision-trees/components/Decisions';

import greenPolygon from '../assets/images/svg/green-polygon.svg';
import purplePolygon from '../assets/images/svg/purple-polygon.svg';

const IsoPage2 = ({ setCurrentPage }) => {
  const [, setLastPage] = useContext(PagesContext);

  useEffect(() => setLastPage('iso'), []);

  const yesHandler = () => setCurrentPage('isoC');
  const noHandler = () => setCurrentPage('isoD');

  return (
    <div className='mw-700 m-auto py-sm-5'>
      <h1 className='page-heading text-center mb-5'>Did you exercise within the 90-day post-termination exercise window (PTE)?</h1>

      <Decisions
        firstCaseContent='Yes'
        secondCaseContent='No'
        firstCaseBackground={greenPolygon}
        secondCaseBackground={purplePolygon}
        firstCaseHandler={yesHandler}
        secondCaseHandler={noHandler}
      />
    </div>
  );
};

IsoPage2.propTypes = {
  setCurrentPage: PropTypes.func
};

export default IsoPage2;
